export { default } from "./FeaturedArticle";
